@if (result(); as item) {
  <div class="flex flex-col">
    <div class="flex flex-row">
    <span class="font-bold"
    >{{item.lagerplatz}} @if (item.bezeichnung !== item.lagerplatz){ {{
        item.bezeichnung}} }</span
    >
    </div>
    <span class="font-normal text-sm text-light"
    >{{ item.lager }} - {{item.name1}}</span
    >
  </div>
}

